module.exports = __webpack_public_path__ + "img/placeholder.16c55c22.png";